import { css } from '@emotion/core'
import { Person } from '@fs/zion-person'
import { colors, H1, LayoutBand, Row, Separator, Skeleton, WhiteTheme } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ResearchHelpTabsSkeleton from './components/ResearchHelpTabsSkeleton'

const minHeightCss = css`
  min-height: 80px;
`

const tuckInSizeCss = css`
  /** Adjusts the margin to tuck in the icon button just like the normal low emphasis IconButton*/
  margin: 0 -8px;
`

type PersonBandSkeletonProps = {
  /** Mirrors PersonBand's disableColoredBackground: gray band instead of the dark placeholder band. */
  disableColoredBackground?: boolean
}

export function PersonBandSkeleton({ disableColoredBackground }: PersonBandSkeletonProps): JSX.Element {
  const bandColor = disableColoredBackground ? colors.gray03 : colors.gray90
  const bandTheme = disableColoredBackground ? undefined : WhiteTheme

  return (
    <LayoutBand as={bandTheme} maxWidth="lg" marginY="xxs" marginX="xxs" color={bandColor}>
      <Row guttersX="xs" css={minHeightCss} alignY="middle">
        <div css={tuckInSizeCss}>
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <Skeleton.IconButton />
        </div>
        <Person loading avatarSize="smaller" lifespanSize="long" />
      </Row>
    </LayoutBand>
  )
}

export default function ResearchHelpPageSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <>
      <PersonBandSkeleton />

      <Separator size="sm" />

      <LayoutBand maxWidth="lg">
        <H1 size="H5">{t('tree-person.research-help.label')}</H1>
        <Separator size="sm" />
        <ResearchHelpTabsSkeleton />
      </LayoutBand>
    </>
  )
}
